<div class="selector-container">
    <mat-button-toggle-group class="date-option-selector" [value]=dateOptionSelected().id  [ngModel]="dateOptionSelected" (ngModelChange)="dateOptionSelected.set($event)" (change)="toggleChanged($event)" aria-label="Favorite Color">
        <ng-container *ngFor="let option of dateSelectorOptions">
            <mat-button-toggle [ngClass]="dateOptionSelected().id === option.id ? 'toggle-active' : ''" [value]="option">{{option.label | transloco}}</mat-button-toggle>
        </ng-container>
    </mat-button-toggle-group>
    <ng-container [ngSwitch]="dateOptionSelected().id">
        <ng-container *ngSwitchCase="leaveNowId">
            <div class="tab-container">
                <app-date-option-form [dateField]="leaveNowDate" [hourField]="leaveNowHour" [disabled]="true"></app-date-option-form>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="leaveAtId">
            <div class="tab-container">
                <app-date-option-form [dateField]="leaveAtDate" [hourField]="leaveAtHour" ></app-date-option-form>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="arriveAtId">
            <div class="tab-container">
                <app-date-option-form [dateField]="arriveAtDate" [hourField]="arriveAtHour" ></app-date-option-form>
            </div>
        </ng-container>
    </ng-container>
</div>